<template>
  <common-dialog ref="dialog" width="600px" show-save-button title="添加手机号标记" id-key="id" :data="data" :form-rules="rules"
    :save-func="saveDataFunc" @close-saved="$emit('close-saved')" close-on-saved>
    <template slot="form">
      <el-form-item prop="phone" label-width="0">
        <el-input v-model="data.phone" placeholder="请输入手机号码，逗号隔开"></el-input>
      </el-form-item>
    </template>
  </common-dialog>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog';
import commonDialog from '@/components/common/dialog';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        id: 0,
        phone: '',
      },
      // api: require('@/api/ent/dp').default,
      rules: {
        phone: [{ required: true, message: '手机号码不能为空' }],
      },
    };
  },
  methods: {
    saveDataFunc() {
      return new Promise((resolve, reject) => {
        resolve({ Code: 0, Msg: null })
      })
    },
  },
};
</script>
